import { NetworkInfo, UnitConfig } from './types';
import BigNumber from 'bignumber.js';

export const NETWORKS: NetworkInfo[] = [
  { 
    name: 'Bitcoin', 
    symbol: 'BTC', 
    coingeckoId: 'bitcoin',
  },
  { 
    name: 'Bitcoin Cash', 
    symbol: 'BCH', 
    coingeckoId: 'bitcoin-cash',
    unitLabelOverrides: {
      mbtc: 'mBCH',
      ubtc: 'μBCH',
      satoshi: 'satoshis',
      megabtc: 'MegaBCH',
      kbtc: 'kiloBCH',
      dabtc: 'decaBCH',
      dbtc: 'deciBCH',
      cbtc: 'centiBCH'
    }
  },
  { 
    name: 'Litecoin', 
    symbol: 'LTC', 
    coingeckoId: 'litecoin',
    unitLabelOverrides: {
      mbtc: 'mLTC',
      ubtc: 'μLTC',
      satoshi: 'litoshis',
      megabtc: 'MegaLTC',
      kbtc: 'kiloLTC',
      dabtc: 'decaLTC',
      dbtc: 'deciLTC',
      cbtc: 'centiLTC'
    }
  },
  { 
    name: 'Dogecoin', 
    symbol: 'DOGE', 
    coingeckoId: 'dogecoin',
    unitLabelOverrides: {
      mbtc: 'mDOGE',
      ubtc: 'μDOGE',
      satoshi: 'koinus',
      megabtc: 'MegaDOGE',
      kbtc: 'kiloDOGE',
      dabtc: 'decaDOGE',
      dbtc: 'deciDOGE',
      cbtc: 'centiDOGE'
    }
  },
  { 
    name: 'Dash', 
    symbol: 'DASH', 
    coingeckoId: 'dash',
    unitLabelOverrides: {
      mbtc: 'mDASH',
      ubtc: 'μDASH',
      satoshi: 'duffs',
      megabtc: 'MegaDASH',
      kbtc: 'kiloDASH',
      dabtc: 'decaDASH',
      dbtc: 'deciDASH',
      cbtc: 'centiDASH'
    }
  },
  { 
    name: 'Ravencoin', 
    symbol: 'RVN', 
    coingeckoId: 'ravencoin',
    unitLabelOverrides: {
      mbtc: 'mRVN',
      ubtc: 'μRVN',
      satoshi: 'talons',
      megabtc: 'MegaRVN',
      kbtc: 'kiloRVN',
      dabtc: 'decaRVN',
      dbtc: 'deciRVN',
      cbtc: 'centiRVN'
    }
  }
];

export const UNITS: Record<string, UnitConfig> = {
  btc: {
    label: 'BTC',
    powerNotation: '1 (10^0)',
    conversionFactor: new BigNumber('100000000'),
    isMainUnit: true,
    showByDefault: true
  },
  mbtc: {
    label: 'mBTC',
    powerNotation: '0.001 (10^-3)',
    conversionFactor: new BigNumber('100000'),
    showByDefault: true
  },
  ubtc: {
    label: 'μBTC',
    powerNotation: '0.000001 (10^-6)',
    conversionFactor: new BigNumber('100'),
    showByDefault: true
  },
  satoshi: {
    label: 'satoshis',
    powerNotation: '0.00000001 (10^-8)',
    conversionFactor: new BigNumber('1'),
    showByDefault: true
  },
  megabtc: {
    label: 'MegaBTC',
    powerNotation: '1,000,000 (10^6)',
    conversionFactor: new BigNumber('100000000000000'),
    showByDefault: false
  },
  kbtc: {
    label: 'kiloBTC',
    powerNotation: '1,000 (10^3)',
    conversionFactor: new BigNumber('100000000000'),
    showByDefault: false
  },
  dabtc: {
    label: 'decaBTC',
    powerNotation: '10 (10^1)',
    conversionFactor: new BigNumber('1000000000'),
    showByDefault: false
  },
  dbtc: {
    label: 'deciBTC',
    powerNotation: '0.1 (10^-1)',
    conversionFactor: new BigNumber('10000000'),
    showByDefault: false
  },
  cbtc: {
    label: 'centiBTC',
    powerNotation: '0.01 (10^-2)',
    conversionFactor: new BigNumber('1000000'),
    showByDefault: false
  },
  finney: {
    label: 'finney',
    powerNotation: '0.0000001 (10^-7)',
    conversionFactor: new BigNumber('10'),
    showByDefault: false
  }
};

export const CONFIG = {
  name: 'Bitcoin Unit Converter',
  description: 'Convert between different Bitcoin and related cryptocurrency denominations',
  networks: NETWORKS,
  units: UNITS,
  defaultNetwork: NETWORKS[0]
}; 